import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, HeartIcon } from 'lucide-react';
import { Avatar } from '../ui/Avatar';
import { MOCK_COMMENTS } from '../../data/mockData';
interface CommentsSheetProps {
  isOpen: boolean;
  onClose: () => void;
}
export function CommentsSheet({
  isOpen,
  onClose
}: CommentsSheetProps) {
  const [newComment, setNewComment] = useState('');
  const EMOJIS = ['😂', '❤️', '🔥', '👏', '😮', '😢'];
  return <AnimatePresence data-id="element-137">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/60 z-40" data-id="element-138" />

          {/* Sheet */}
          <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="absolute bottom-0 left-0 right-0 h-[75%] bg-surface rounded-t-3xl z-50 flex flex-col" data-id="element-139">
            {/* Handle */}
            <div className="w-full flex justify-center py-3" data-id="element-140">
              <div className="w-12 h-1.5 bg-border rounded-full" data-id="element-141" />
            </div>

            {/* Header */}
            <div className="px-4 pb-3 flex items-center justify-between border-b border-border" data-id="element-142">
              <div className="w-8" data-id="element-143" /> {/* Spacer */}
              <h3 className="text-white font-bold text-sm" data-id="element-144">1,245 comments</h3>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center bg-surface2 rounded-full text-softGray hover:text-white" data-id="element-145">
                <XIcon size={18} data-id="element-146" />
              </button>
            </div>

            {/* Comments List */}
            <div className="flex-1 overflow-y-auto px-4 py-4 space-y-6 no-scrollbar" data-id="element-147">
              {MOCK_COMMENTS.map(comment => <div key={comment.id} className="flex gap-3" data-id="element-148">
                  <Avatar src={comment.user.avatar} alt={comment.user.username} size="sm" data-id="element-149" />
                  <div className="flex-1" data-id="element-150">
                    <div className="flex items-center gap-2 mb-1" data-id="element-151">
                      <span className="text-softGray text-xs font-medium" data-id="element-152">
                        {comment.user.username}
                      </span>
                      <span className="text-border text-xs" data-id="element-153">•</span>
                      <span className="text-softGray text-xs" data-id="element-154">
                        {comment.time}
                      </span>
                    </div>
                    <p className="text-white text-sm mb-2" data-id="element-155">{comment.text}</p>
                    <button className="text-softGray text-xs font-medium hover:text-white" data-id="element-156">
                      Reply
                    </button>
                  </div>
                  <div className="flex flex-col items-center gap-1" data-id="element-157">
                    <button className="text-softGray hover:text-neonOrange transition-colors" data-id="element-158">
                      <HeartIcon size={16} data-id="element-159" />
                    </button>
                    <span className="text-softGray text-[10px]" data-id="element-160">
                      {comment.likes}
                    </span>
                  </div>
                </div>)}
            </div>

            {/* Input Area */}
            <div className="border-t border-border bg-surface p-4 pb-8" data-id="element-161">
              {/* Emoji Quick Bar */}
              <div className="flex justify-between mb-3 px-2" data-id="element-162">
                {EMOJIS.map(emoji => <button key={emoji} onClick={() => setNewComment(prev => prev + emoji)} className="text-2xl hover:scale-110 transition-transform" data-id="element-163">
                    {emoji}
                  </button>)}
              </div>

              <div className="flex items-center gap-3" data-id="element-164">
                <Avatar alt="Me" size="sm" data-id="element-165" />
                <div className="flex-1 relative" data-id="element-166">
                  <input type="text" value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Add a comment..." className="w-full bg-surface2 border border-border rounded-full py-2.5 pl-4 pr-12 text-sm text-white placeholder:text-softGray focus:outline-none focus:border-primary" data-id="element-167" />
                  <button className={`absolute right-3 top-1/2 -translate-y-1/2 font-bold text-sm ${newComment.trim() ? 'text-primary' : 'text-softGray'}`} disabled={!newComment.trim()} data-id="element-168">
                    Post
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}